import {
    AUTH_ACTION_LOGIN,
    AUTH_ACTION_LOGOUT,
    AUTH_ACTION_MY_INFO,
    AUTH_ACTION_BUY_ELEVATOR,
    DASHBOARD_ELEVATE_SUCCESS
} from '../actions/constants'

const defaultState = {
    info: {},
    token: undefined
};

export default (state = defaultState, action) => {
    switch (action.type){
        case AUTH_ACTION_LOGIN:
            return {
                ...state,
                token: action.payload.token
            };
        case AUTH_ACTION_LOGOUT:
            return defaultState;
        case AUTH_ACTION_MY_INFO:
            return {
                ...state,
                info: action.payload
            }
        case AUTH_ACTION_BUY_ELEVATOR:
            return {
                ...state,
                elevators: action.payload.elevators
            }
        case DASHBOARD_ELEVATE_SUCCESS:
            return {
                ...state,
                info: {...state.info, elevators: state.info.elevators - 1}
            }
        default:
            return state;
    }
};